import React, { useContext, useState } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import { SmallCardButton } from "./../Controls";

const PropertyUsage: React.FunctionComponent<{
  onSubmit?: (value: TypeOfUsageProperty) => void;
}> = (props: { onSubmit?: (value: TypeOfUsageProperty) => void }) => {
  const loanFormContext = useContext(LoanFormContext);

  const handleSubmit = (value: TypeOfUsageProperty) => {
    if (props.onSubmit) props.onSubmit(value);
  };

  return (
    <div>
      <FormStep
        header={
          <h1 className="heading-main">How will this property be used?</h1>
        }
      >
        <div className="form-cardBtns-wrapper form-inputs-wrapper">
          <SmallCardButton
            label="Primary Home"
            icon={<i className="icon-nbr-main-home"></i>}
            onClick={() => {
              handleSubmit("primary home");
            }}
            anim
            active={
              loanFormContext.propertyUsage?.value === "primary home"
                ? true
                : false
            }
          />
          <SmallCardButton
            label="Secondary Home"
            icon={<i className="icon-nbr-map-point"></i>}
            onClick={() => {
              handleSubmit("secondary home");
            }}
            anim
            active={
              loanFormContext.propertyUsage?.value === "secondary home"
                ? true
                : false
            }
          />
          <SmallCardButton
            label="Rental Property"
            icon={<i className="icon-nbr-rent"></i>}
            onClick={() => {
              handleSubmit("rental property");
            }}
            anim
            active={
              loanFormContext.propertyUsage?.value === "rental property"
                ? true
                : false
            }
          />
        </div>
      </FormStep>
    </div>
  );
};

export type TypeOfUsageProperty =
  | "primary home"
  | "secondary home"
  | "rental property";

export default PropertyUsage;
